import React, { useContext, useEffect, useState } from "react";
import global_context from "../../../static_vars";
import FarsightApi from "../../../ApiWrapper";
import StyledDatagrid, { ColumnTypes } from "../styled_datagrid";
import { Checkbox, Stack, Typography } from "@mui/material";
import { GridCellEditStopParams, GridEnrichedColDef, GridPagination, GridSlotsComponentsProps, GridToolbarExport } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import { GridFooterContainer } from "@mui/x-data-grid";

export default function OffseasonShortlistStats(props: { shortlist: any; from: number; until: number; metrics: any[]; target: string }) {
    const [rows, setRows] = useState([] as any[]);
    const [loading, setLoading] = useState(false);

    const effect = () => {
        if (props.shortlist) {
            setLoading(true);
            FarsightApi.get_request("ShortlistStats", {
                from: props.from,
                until: props.until,
                id: props.shortlist.id,
                metrics: props.metrics.map((metric: any) => metric.code),
                target: props.target,
            })
                .then((data) => setRows(data))
                .then(() => setLoading(false));
        }
    };

    useEffect(effect, [props]);

    const grid_columns = [ColumnTypes.player("player", "Player")];

    // @ts-ignore
    const nc = props.metrics.map((metric: any) =>
        ColumnTypes[metric.type](metric.code, metric.short, {
            description: metric.desc,
        }),
    );
    grid_columns.push(...nc);

    return (
        <StyledDatagrid
            rowHeight={60}
            sx={{
                width: "100%",
                "& .header": {
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                },
                "& .border-left": {
                    borderLeft: "solid grey",
                    borderWidth: "2px",
                },
            }}
            getRowId={(row: any) => rows.indexOf(row)}
            initialState={{
                sorting: {
                    sortModel: [{ field: "date", sort: "desc" }],
                },
            }}
            columns={grid_columns}
            rows={rows}
            hideFooter={false}
            loading={loading}
            components={{
                Footer: CustomFooterStatusComponent,
            }}
            componentsProps={{
                footer: { undefined },
            }}
        />
    );
}

export function CustomFooterStatusComponent(props: any) {
    return (
        <GridFooterContainer sx={{ alignItems: "space-between" }}>
            <Stack direction={"row"} spacing={1} sx={{ m: 1 }}>
                <GridToolbarExport
                    csvOptions={{
                        fileName: "Shortlist stats",
                    }}
                />
            </Stack>
            <GridPagination />
        </GridFooterContainer>
    );
}
